export enum MaturedStatusIndicator {
	UNSET = 'UNSET',
	STATUS_CODE = 'STATUS_CODE',
	MATURED_DATE = 'MATURED_DATE',
	STATUS_CODE_OR_MATURED_DATE = 'STATUS_CODE_OR_MATURED_DATE',
	STATUS_CODE_AND_MATURED_DATE = 'STATUS_CODE_AND_MATURED_DATE',
}

export default MaturedStatusIndicator;
